import { LoadingStatusEnum } from '../../../../store/types'
import { BlockedIp } from '../api/types'

const initialState = {
  list: [] as BlockedIp[],
  search: '',
  loading: LoadingStatusEnum.Idle,
}

export type StateType = typeof initialState

export default initialState
